import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LegacyRoutingService {

  private readonly sammyRoutes: any = {};

  constructor() {
    this.sammyRoutes = (window as any).KO_SAMMY_ROUTE_BRIDGE;
  }

  get(): any {
    return this.sammyRoutes;
  }
}
